export const NOTIFICATION_CENTER_TOUR_EVENT = 'legal-web:notification-center-open-change'

export const NOTIFICATION_GUIDED_TOUR_STORAGE_KEY = 'legal-web:tour:notification-settings:v1'

export function setNotificationCenterTourOpen(open: boolean): void {
  if (typeof window === 'undefined') return
  window.dispatchEvent(
    new CustomEvent(NOTIFICATION_CENTER_TOUR_EVENT, {
      detail: { open },
    }),
  )
}
